// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1xo8t","filter":"styles_filter__30ANa"};